import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en-gb', 'en-us'],
    defaultLocale: 'en-gb',
    // Always include the locale prefix in URLs (prevents hreflang pointing at / or other redirecting URLs)
    localePrefix: 'always',
    localeDetection: false, // Disable automatic detection since we handle it in middleware
    pathnames: {
        '/who-we-help/fe-colleges': {
            'en-gb': '/who-we-help/fe-colleges',
            'en-us': '/who-we-help/community-colleges'
        },
        '/who-we-help/community-colleges': {
            'en-gb': '/who-we-help/fe-colleges',
            'en-us': '/who-we-help/community-colleges'
        },
    }
});